import MotionSection from "../common/MotionSection";
import CountryActionLink from "./CountryActionLink";

function CountryFinalCta({ country }) {
  return (
    <MotionSection className="pb-20 pt-10 md:pb-24 md:pt-12">
      <div className="mx-auto w-full max-w-7xl px-6">
        <div className="relative overflow-hidden rounded-[2rem] bg-cta-glow px-6 py-12 md:px-10 md:py-16">
          <div className="absolute -left-16 bottom-0 h-56 w-56 rounded-full bg-white/10 blur-3xl" />
          <div className="absolute -right-20 top-0 h-56 w-56 rounded-full bg-warm-gold/20 blur-3xl" />

          <div className="relative mx-auto max-w-3xl text-center">
            <h2 className="text-2xl text-soft-white sm:text-3xl md:text-5xl">{country.finalCta.title}</h2>
            <p className="mt-5 text-sm leading-relaxed text-sky-glow/85 sm:text-base md:text-lg">{country.finalCta.subtitle}</p>

            <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <CountryActionLink
                variant="ctaPrimary"
                to={country.finalCta.primary.to}
                label={country.finalCta.primary.label}
              />
              <CountryActionLink
                variant="ctaSecondary"
                to={country.finalCta.secondary.to}
                label={country.finalCta.secondary.label}
              />
            </div>
          </div>
        </div>
      </div>
    </MotionSection>
  );
}

export default CountryFinalCta;
